import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "catalog" };
const _hoisted_2 = { class: "catalog__categories-toggle-mobile" };
import { ref, onMounted, watch } from 'vue';
import CategoryTree from "../components/CategoryTree.vue";
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import { useRoute } from "vue-router";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
import CatalogProducts from "../components/CatalogProducts.vue";
import Spinner from '@astina/paloma-common-ui/src/components/Spinner.vue';
import config from "../services/PortalConfig";
import events from "@astina/paloma-common-ui/src/services/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogCategoryViewV2',
    props: {
        viewMode: {}
    },
    setup(__props) {
        const route = useRoute();
        const loading = ref(true);
        const categories = ref(null);
        const categoryCode = ref(null);
        const showCategoriesMobile = ref(false);
        const urlSearchQuery = ref((route.query['search'] && '' + route.query['search']) || null);
        onMounted(() => {
            updateCategoryCode();
            productRepository.listCategories(config.categories.depth, false, config.categories.includeEmpty)
                .then(cat => categories.value = cat)
                .catch(() => categories.value = [])
                .finally(() => loading.value = false);
        });
        watch(() => route.params, updateCategoryCode);
        function updateCategoryCode() {
            categoryCode.value = RouterUtils.singleParam(route, 'category') || null;
        }
        function onCatalogProductsScroll(event) {
            events.$emit('catalog.products-scroll', event);
        }
        return (_ctx, _cache) => {
            const _component_RouterView = _resolveComponent("RouterView");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["catalog__categories", { 'catalog__categories--show-mobile': showCategoriesMobile.value }])
                }, [
                    _createVNode(Spinner, {
                        loading: !categories.value
                    }, null, 8, ["loading"]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (categories.value)
                        ? (_openBlock(), _createBlock(CategoryTree, {
                            key: 0,
                            categories: categories.value,
                            "active-category": categoryCode.value,
                            onSelectCategory: _cache[0] || (_cache[0] = ($event) => (showCategoriesMobile.value = false))
                        }, null, 8, ["categories", "active-category"]))
                        : _createCommentVNode("", true)
                ], 2),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("div", {
                    class: "catalog__products",
                    onScrollPassive: onCatalogProductsScroll
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showCategoriesMobile.value = !showCategoriesMobile.value), ["prevent"])),
                            class: "button button--outline",
                            href: "#"
                        }, _toDisplayString(_ctx.$t('products.categories')), 1)
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (!loading.value)
                        ? (_openBlock(), _createBlock(CatalogProducts, {
                            key: 0,
                            "category-code": categoryCode.value,
                            "view-mode": __props.viewMode,
                            "search-query": urlSearchQuery.value
                        }, null, 8, ["category-code", "view-mode", "search-query"]))
                        : _createCommentVNode("", true),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createVNode(_component_RouterView)
                ], 32)
            ]));
        };
    }
});
